import type { ImageUploaded } from 'src/shared/telemetry';
import { imageUploaded } from 'src/shared/telemetry';
import { logError } from 'src/shared/telemetry/logger';

import type { HomeownerAppTrackingData } from '../providers/HomeownerAppProvider';

interface ImageUploadTracker extends HomeownerAppTrackingData {
  file_size_mb: number;
  file_type: string;
}

const initializeTracker = (initialTrackingData?: ImageUploadTracker) => {
  let previousTrackedTimestamp = new Date().getTime();
  let existingTrackingData: ImageUploaded = {
    ...initialTrackingData,
    track_id: '',
    request_timestamp_ms: previousTrackedTimestamp,
  };
  return (aiOriginalImageId?: number) => {
    const currentTimeMS = new Date().getTime();
    if (!existingTrackingData.request_timestamp_ms) {
      logError(
        new Error('Image upload tracking data missing request_timestamp_ms'),
      );
      return;
    }
    if (existingTrackingData.track_id === 'image-upload-part-3') {
      // Already sent all 3 parts of the image uploaded event
      return;
    }
    if (existingTrackingData.upload_to_cloud_ms) {
      existingTrackingData = {
        ...existingTrackingData,
        response_timestamp_ms: currentTimeMS,
        total_upload_time_ms:
          currentTimeMS - existingTrackingData.request_timestamp_ms,
        hyperion_response_ms: currentTimeMS - previousTrackedTimestamp,
        track_id: 'image-upload-part-3',
      };
    } else if (existingTrackingData?.hyperion_placeholder_ms) {
      existingTrackingData = {
        ...existingTrackingData,
        upload_to_cloud_ms: currentTimeMS - previousTrackedTimestamp,
        track_id: 'image-upload-part-2',
      };
      previousTrackedTimestamp = currentTimeMS;
    } else if (
      existingTrackingData?.request_timestamp_ms &&
      aiOriginalImageId
    ) {
      existingTrackingData = {
        ...existingTrackingData,
        ai_original_image_id: aiOriginalImageId,
        hyperion_placeholder_ms:
          currentTimeMS - existingTrackingData.request_timestamp_ms,
        track_id: 'image-upload-part-1',
      };
      previousTrackedTimestamp = currentTimeMS;
    }
    imageUploaded(existingTrackingData);
  };
};

export { initializeTracker };
